<template>
  <van-dialog class="pc-dialog" v-model="mask" :before-close="closeMask" confirm-button-text="取消" confirm-button-color="black">
    <div class="content">
      <img :src="qrcode" class="qrcode" alt="微信登录二维码">
      <p class="tip">手机微信微信扫码登录</p>
      <p class="tip" v-if="!isWeixin"><a href="https://shimo.im/docs/XWjqqxjJrRTJkvtH" target="_blank">微信怎么扫描自己手机上的二维码?</a></p>
    </div>
  </van-dialog>
</template>
<script>
import { statusQrcode, createQrcode } from '@/api/qrcode'
export default {
   data () {
    return {
      qrcode: '',
      timer: null,
      mask: true,
      qrcodeid: '',
    }
  },
  async created () {
    const res = await createQrcode()
    if (res.code != 0) {
      return this.$toast.fail('请稍后重试')
    }
    this.qrcode = res.data.image
    this.qrcodeid = res.data.qrcodeid
    this.mask = true

    let times = 0
    this.timer = setInterval(async () => {
      const res = await statusQrcode(this.qrcodeid)
      if (res.code == 0) {
        this.hideLoginDialog()
        clearInterval(this.timer)
        localStorage.setItem('token', res.data.token)
        this.$toast.success('登录成功')
        window.location.reload()
      } else {
        times ++
        if (times > 60) {
          this.hideLoginDialog()
          clearInterval(this.timer)
        }
      }
    }, 1500)
  },
  methods: {
    closeMask (_, done) {
      this.timer && clearInterval(this.timer)
      this.hideLoginDialog()
      done()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_var.scss";

.van-dialog {
  .content {
    text-align: center;
    padding: 20px 20px 10px 20px;
  }
  .qrcode {
    width: 200px;
    height: 200px;
  }
  .tip {
    font-size: 13px;
    color: #666;
    &.logout {
      margin-top: 15px;
    }
    a {
      font-size: 13px;
      margin-top: 10px;
    }
  }
  &.info-dialog {
    .vipinfo {
      margin: 15px 0;
      padding: 10px;
      border-radius: 4px;
      background-color: rgba($theme-color, 0.2);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      text-align: left;
      .em {
        margin-bottom: 5px;
      }
      .van-button {
        padding: 0 10px;
      }
    }
  }
}
</style>
